module.exports = __webpack_public_path__ + "img/live-chat.64ad1055.png";